import { LanguageTag } from './converters/convertCountryToLanguageTag';

const DIAGRAPHS_TO_UMLAUTS: Record<string, string> = {
  Ae: 'Ä',
  Oe: 'Ö',
  Ue: 'Ü',
  ae: 'ä',
  oe: 'ö',
  ue: 'ü'
};

const replaceDiagraphsWithUmlauts = (input: string): string => {
  return input.replace(/Ae|Oe|Ue|ae|oe|ue/g, (match) => DIAGRAPHS_TO_UMLAUTS[match] || match);
};

const localeBasedReplacements: Record<string, (input: string) => string> = {
  [LanguageTag.DE_DE]: replaceDiagraphsWithUmlauts,
  [LanguageTag.DE_AT]: replaceDiagraphsWithUmlauts,
  [LanguageTag.DE_CH]: replaceDiagraphsWithUmlauts
};

const replaceDiagraphsWithDiacritics = (input: string, locale: string): string => {
  const replacementFunction = localeBasedReplacements[locale];

  let returnValue = input;

  if (replacementFunction) {
    returnValue = replacementFunction(input);
  }

  return returnValue;
};

export default replaceDiagraphsWithDiacritics;
